import {connect} from 'react-redux';
import BlogPost from './BlogPost';

const getActualState = (state) =>(
    {
        len:state.len
    }
)

const actions = (dispatch) =>(
    {
        eventsActions: (type,payload) => dispatch({type,...payload})
    }
)

export default connect(getActualState,actions)(BlogPost);